<template>
  <div class="bg-white px-4 py-5 sm:p-6">
    <div class="grid grid-cols-6 gap-6">
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="dia" class="block text-sm font-medium text-gray-700">Día</label>
        <input type="number" min="1" :max="maxDays" :value="loadData.dia" id="dia"
               @change="(diaNew)=>{$emit('updateValues', {'dia': customUpdateValueData('dia', diaNew.target.value)}); validateDay(customUpdateValueData('dia', diaNew.target.value)); validateUniqueDiaAndTipo('dia', diaNew.target.value)}"
               :class="(view==='actualizar'?'bg-gray-50':'') + ' mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'"
               :disabled="view==='actualizar'"
        >

      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="valor" class="block text-sm font-medium text-gray-700">Valor</label>
        <input type="text" id="valor" :value="loadData.valor"
               @change="(valorNew)=>$emit('updateValues', {'valor': customUpdateValueData('valor', valorNew.target.value)})"
               class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="tipo" class="block text-sm font-medium text-gray-700">Tipo</label>
        <select id="tipo" :value="loadData.tipo"
                @change="(tipoNew)=>{$emit('updateValues', {'tipo': customUpdateValueData('tipo', tipoNew.target.value)}); validateUniqueDiaAndTipo('tipo', tipoNew.target.value);}"
                :class="(view==='actualizar'?'bg-gray-50':'') + ' border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'"
                :disabled="view==='actualizar'">
          <option value="" selected>Seleccione un tipo de movimiento...</option>
          <option value="ingreso">Ingreso</option>
          <option value="egreso">Egreso</option>
        </select>
      </div>
    </div>
    <div class="my-3">
      <p class="text-left font-bold">Nota:</p>
      <p class="text-left"><b>-</b> Los números con decimales deben ir separados por un punto.</p>
      <template>
        <p class="text-left"><b>-</b> Al crearse un movimiento, también se crea su equivalente con el tipo de
          movimiento
          opuesto.</p>
        <p class="text-left ml-3"><b>EJ:</b> Al crear un movimiento de tipo "ingreso". Se crea otro
          movimiento de tipo "egreso", con su valor en 0.</p>
      </template>
    </div>
  </div>
</template>

<script>
import {swal} from "@/common/constants/variables";
import {getCurrentMonth, useAPIRest, generateTextError, verifyHttpCode} from "@/common/constants";

export default {
  name: "MovimientosBancariosCrearActualizarComponent",
  props: ['selectedExtractoBancario', 'authToken', 'loadData', 'customUpdateValueData', 'maxDays', 'view', 'mes', 'year'],
  methods: {
    validateDay(day) {
      if (day <= 0 || day > this.maxDays) {
        this.$emit('updateValues', {'dia': ''})
        if (day > this.maxDays) swal.fire(`¡El mes de ${getCurrentMonth(this.mes)} solo tiene ${this.maxDays} días!`, '', 'error');
        else swal.fire(`¡El día ingresado no es valido!`, '', 'error');
      }
    },
    async validateUniqueDiaAndTipo(key, value) {
      if(key === 'dia'){
        if(![value, this.loadData.tipo].includes('')) {
          await useAPIRest(process.env.VUE_APP_NEST_MOVIMIENTOBANCARIO_FINDALL, 'GET', this.authToken, undefined, {
          where: 'extracto_bancario_id = ' + this.selectedExtractoBancario.id + ', table.dia =' + value + ', table.tipo = "' + this.loadData.tipo + '"'
          }).then(async resJSON => {
            const {statusCode} = resJSON;
            delete resJSON.statusCode;
            const textoError = generateTextError(resJSON);
            if (verifyHttpCode(statusCode, 'success')) {
              if(resJSON.data.length){
                this.$emit('updateValues', {'dia': ''});
                this.$emit('updateValues', {'tipo': ''});
                swal.fire(`¡Ya existe un movimiento bancario con el día y tipo ingresados!`, '', 'error');
              }
            } else await swal.fire(textoError, '', 'error');
          });
        }
      }
      else if(key ==='tipo'){
        if(![value, this.loadData.dia].includes('')) {
          await useAPIRest(process.env.VUE_APP_NEST_MOVIMIENTOBANCARIO_FINDALL, 'GET', this.authToken, undefined, {
          where: 'extracto_bancario_id = ' + this.selectedExtractoBancario.id + ', table.dia =' + this.loadData.dia + ', table.tipo = "' + value + '"'
          }).then(async resJSON => {
            const {statusCode} = resJSON;
            delete resJSON.statusCode;
            const textoError = generateTextError(resJSON);
            if (verifyHttpCode(statusCode, 'success')) {
              if(resJSON.data.length){
                this.$emit('updateValues', {'dia': ''});
                this.$emit('updateValues', {'tipo': ''});
                swal.fire(`¡Ya existe un movimiento bancario con el día y tipo ingresados!`, '', 'error');
              }
            } else await swal.fire(textoError, '', 'error');
          });
        }
      }
    }
  },
}
</script>